import { render, staticRenderFns } from "./loyalty-exchange.vue?vue&type=template&id=372bf698&scoped=true&"
import script from "./loyalty-exchange.ts?vue&type=script&lang=ts&"
export * from "./loyalty-exchange.ts?vue&type=script&lang=ts&"
import style0 from "./loyalty-exchange.scss?vue&type=style&index=0&id=372bf698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372bf698",
  null
  
)

component.options.__file = "loyalty-exchange.vue"
export default component.exports